const code = 'meubairro';
const codeAPI = 'meubairro';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};